import { render, staticRenderFns } from "./PanesDescription.vue?vue&type=template&id=398b8830&scoped=true"
import script from "./PanesDescription.vue?vue&type=script&lang=ts"
export * from "./PanesDescription.vue?vue&type=script&lang=ts"
import style0 from "./PanesDescription.vue?vue&type=style&index=0&id=398b8830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b8830",
  null
  
)

export default component.exports